"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateUserUpdatedDTO = exports.ScoreDTO = exports.ScoreDiffDTO = exports.ScoreListDTO = exports.MacroTutoProgressionDTO = exports.GetAllianceInfoDTO = exports.UpdateUserDTO = exports.DeleteUsersDTO = exports.GetTopPlayersDTO = exports.GetUserDTO = exports.LoginByTokenDTO = exports.LoginByTokenResponseDTO = exports.LoginResponseDTO = exports.AuthWithAppleDTO = exports.AuthWithGoogleDTO = exports.LoginDTO = exports.AuthUserDTO = exports.UsersSearchParamsDTO = exports.UserFilterDTO = exports.TopPlayersDTO = exports.UserPublicListDTO = exports.UserPrivateDTO = exports.UserPublicDTO = exports.ScoreEntry = exports.MacroTutos = exports.BanditType = exports.BotType = exports.UserRole = exports.getLangFromCode = exports.Language = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Alliance_1 = require("./Alliance");
const Avatar_1 = require("./Avatar");
const GeoIp_1 = require("./GeoIp");
var Language;
(function (Language) {
    Language["French"] = "fr_FR";
    Language["English"] = "en_US";
    Language["German"] = "de_DE";
})(Language = exports.Language || (exports.Language = {}));
function getLangFromCode(langCode) {
    if (langCode == null)
        return undefined;
    return Object.values(Language).find((value) => value.toLowerCase() === langCode.toLowerCase());
}
exports.getLangFromCode = getLangFromCode;
var UserRole;
(function (UserRole) {
    UserRole[UserRole["Anonymous"] = 0] = "Anonymous";
    UserRole[UserRole["User"] = 1] = "User";
    UserRole[UserRole["Admin"] = 2] = "Admin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var BotType;
(function (BotType) {
    BotType["FakeHuman"] = "FakeHuman";
    BotType["Bandit"] = "Bandit";
})(BotType = exports.BotType || (exports.BotType = {}));
var BanditType;
(function (BanditType) {
    BanditType["TheBrutes"] = "TheBrutes";
    BanditType["WarManiacs"] = "WarManiacs";
    BanditType["ScaryDentist"] = "ScaryDentist";
    BanditType["GaiaLovers"] = "GaiaLovers";
})(BanditType = exports.BanditType || (exports.BanditType = {}));
var MacroTutos;
(function (MacroTutos) {
    MacroTutos["TutoADone"] = "TutoADone";
    MacroTutos["FirstChest"] = "FirstChest";
    MacroTutos["FirstBattle"] = "FirstBattle";
    MacroTutos["FirstBattleStarted"] = "FirstBattleStarted";
    MacroTutos["FirstPlaceCaptured"] = "FirstPlaceCaptured";
    MacroTutos["WoodAndFarmUnlocked"] = "WoodAndFarmUnlocked";
})(MacroTutos = exports.MacroTutos || (exports.MacroTutos = {}));
var ScoreEntry;
(function (ScoreEntry) {
    ScoreEntry["VanLevel"] = "VanLevel";
    ScoreEntry["SawmillLevel"] = "SawmillLevel";
    ScoreEntry["FarmLevel"] = "FarmLevel";
    ScoreEntry["QuarryLevel"] = "QuarryLevel";
    ScoreEntry["FoundryLevel"] = "FoundryLevel";
    ScoreEntry["MappingCenterLevel"] = "MappingCenterLevel";
    ScoreEntry["DormitoryLevel"] = "DormitoryLevel";
    ScoreEntry["PlacesAndUpgradesI"] = "PlacesAndUpgradesI";
    ScoreEntry["PlacesAndUpgradesII"] = "PlacesAndUpgradesII";
    ScoreEntry["PlacesAndUpgradesIII"] = "PlacesAndUpgradesIII";
    ScoreEntry["Characters1Star"] = "Characters1Star";
    ScoreEntry["Characters2Stars"] = "Characters2Stars";
    ScoreEntry["Characters3Stars"] = "Characters3Stars";
    ScoreEntry["Top4CharactersLevels"] = "Top4CharactersLevels";
    ScoreEntry["WinEasy"] = "WinEasy";
    ScoreEntry["WinNormal"] = "WinNormal";
    ScoreEntry["WinHard"] = "WinHard";
    ScoreEntry["WinVeryHard"] = "WinVeryHard";
    ScoreEntry["WinImpossible"] = "WinImpossible";
})(ScoreEntry = exports.ScoreEntry || (exports.ScoreEntry = {}));
let UserPublicDTO = (() => {
    class UserPublicDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UserPublicDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(20),
        __metadata("design:type", String)
    ], UserPublicDTO.prototype, "username", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UserPublicDTO.prototype, "mmr", void 0);
    return UserPublicDTO;
})();
exports.UserPublicDTO = UserPublicDTO;
let UserPrivateDTO = (() => {
    class UserPrivateDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UserPrivateDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(20),
        __metadata("design:type", String)
    ], UserPrivateDTO.prototype, "username", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UserPrivateDTO.prototype, "mmr", void 0);
    return UserPrivateDTO;
})();
exports.UserPrivateDTO = UserPrivateDTO;
class UserPublicListDTO {
}
exports.UserPublicListDTO = UserPublicListDTO;
class TopPlayersDTO {
}
exports.TopPlayersDTO = TopPlayersDTO;
let UserFilterDTO = (() => {
    class UserFilterDTO {
    }
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], UserFilterDTO.prototype, "includeDisabled", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UserFilterDTO.prototype, "query", void 0);
    return UserFilterDTO;
})();
exports.UserFilterDTO = UserFilterDTO;
class UsersSearchParamsDTO {
}
exports.UsersSearchParamsDTO = UsersSearchParamsDTO;
let AuthUserDTO = (() => {
    class AuthUserDTO {
    }
    __decorate([
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], AuthUserDTO.prototype, "email", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(10),
        class_validator_1.MaxLength(50),
        __metadata("design:type", String)
    ], AuthUserDTO.prototype, "deviceId", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(16),
        class_validator_1.MaxLength(16),
        __metadata("design:type", String)
    ], AuthUserDTO.prototype, "secret", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(80),
        __metadata("design:type", String)
    ], AuthUserDTO.prototype, "deviceDescription", void 0);
    return AuthUserDTO;
})();
exports.AuthUserDTO = AuthUserDTO;
let LoginDTO = (() => {
    class LoginDTO {
    }
    __decorate([
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], LoginDTO.prototype, "email", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(6),
        class_validator_1.MaxLength(50),
        __metadata("design:type", String)
    ], LoginDTO.prototype, "password", void 0);
    return LoginDTO;
})();
exports.LoginDTO = LoginDTO;
let AuthWithGoogleDTO = (() => {
    class AuthWithGoogleDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AuthWithGoogleDTO.prototype, "deviceId", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(80),
        __metadata("design:type", String)
    ], AuthWithGoogleDTO.prototype, "deviceDescription", void 0);
    return AuthWithGoogleDTO;
})();
exports.AuthWithGoogleDTO = AuthWithGoogleDTO;
let AuthWithAppleDTO = (() => {
    class AuthWithAppleDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], AuthWithAppleDTO.prototype, "deviceId", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(80),
        __metadata("design:type", String)
    ], AuthWithAppleDTO.prototype, "deviceDescription", void 0);
    return AuthWithAppleDTO;
})();
exports.AuthWithAppleDTO = AuthWithAppleDTO;
class LoginResponseDTO {
}
exports.LoginResponseDTO = LoginResponseDTO;
class LoginByTokenResponseDTO {
}
exports.LoginByTokenResponseDTO = LoginByTokenResponseDTO;
let LoginByTokenDTO = (() => {
    class LoginByTokenDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], LoginByTokenDTO.prototype, "token", void 0);
    return LoginByTokenDTO;
})();
exports.LoginByTokenDTO = LoginByTokenDTO;
let GetUserDTO = (() => {
    class GetUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], GetUserDTO.prototype, "id", void 0);
    return GetUserDTO;
})();
exports.GetUserDTO = GetUserDTO;
let GetTopPlayersDTO = (() => {
    class GetTopPlayersDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], GetTopPlayersDTO.prototype, "mapCoordinates", void 0);
    return GetTopPlayersDTO;
})();
exports.GetTopPlayersDTO = GetTopPlayersDTO;
let DeleteUsersDTO = (() => {
    class DeleteUsersDTO {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_validator_1.IsUUID(undefined, { each: true }),
        __metadata("design:type", Array)
    ], DeleteUsersDTO.prototype, "ids", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], DeleteUsersDTO.prototype, "hardDelete", void 0);
    return DeleteUsersDTO;
})();
exports.DeleteUsersDTO = DeleteUsersDTO;
let UpdateUserDTO = (() => {
    class UpdateUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsEmail(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "email", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(2),
        class_validator_1.MaxLength(20),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "username", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(6),
        class_validator_1.MaxLength(50),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "password", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.MinLength(6),
        class_validator_1.MaxLength(50),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "currentPassword", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], UpdateUserDTO.prototype, "notificationsNewsPush", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], UpdateUserDTO.prototype, "notificationsPlacePush", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], UpdateUserDTO.prototype, "notificationsBattlePush", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Boolean)
    ], UpdateUserDTO.prototype, "notificationsFriendshipPush", void 0);
    __decorate([
        class_validator_1.IsEnum(Alliance_1.AllianceRoles),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "allianceRole", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "allianceId", void 0);
    __decorate([
        class_validator_1.IsEnum(Avatar_1.AvatarNames),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UpdateUserDTO.prototype, "avatarId", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UpdateUserDTO.prototype, "victoriesCount", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UpdateUserDTO.prototype, "defeatsCount", void 0);
    return UpdateUserDTO;
})();
exports.UpdateUserDTO = UpdateUserDTO;
let GetAllianceInfoDTO = (() => {
    class GetAllianceInfoDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetAllianceInfoDTO.prototype, "allianceId", void 0);
    return GetAllianceInfoDTO;
})();
exports.GetAllianceInfoDTO = GetAllianceInfoDTO;
let MacroTutoProgressionDTO = (() => {
    class MacroTutoProgressionDTO {
    }
    __decorate([
        class_validator_1.IsEnum(MacroTutos),
        __metadata("design:type", String)
    ], MacroTutoProgressionDTO.prototype, "macroTuto", void 0);
    return MacroTutoProgressionDTO;
})();
exports.MacroTutoProgressionDTO = MacroTutoProgressionDTO;
class ScoreListDTO {
}
exports.ScoreListDTO = ScoreListDTO;
let ScoreDiffDTO = (() => {
    class ScoreDiffDTO {
    }
    __decorate([
        class_validator_1.IsEnum(ScoreEntry),
        __metadata("design:type", String)
    ], ScoreDiffDTO.prototype, "entry", void 0);
    __decorate([
        class_validator_1.IsInt(),
        __metadata("design:type", Number)
    ], ScoreDiffDTO.prototype, "valueChange", void 0);
    return ScoreDiffDTO;
})();
exports.ScoreDiffDTO = ScoreDiffDTO;
let ScoreDTO = (() => {
    class ScoreDTO {
    }
    __decorate([
        class_validator_1.IsEnum(ScoreEntry),
        __metadata("design:type", String)
    ], ScoreDTO.prototype, "entry", void 0);
    __decorate([
        class_validator_1.IsInt(),
        __metadata("design:type", Number)
    ], ScoreDTO.prototype, "occurrences", void 0);
    __decorate([
        class_validator_1.IsInt(),
        __metadata("design:type", Number)
    ], ScoreDTO.prototype, "valuePerOccurrence", void 0);
    __decorate([
        class_validator_1.IsInt(),
        __metadata("design:type", Number)
    ], ScoreDTO.prototype, "total", void 0);
    return ScoreDTO;
})();
exports.ScoreDTO = ScoreDTO;
class PrivateUserUpdatedDTO {
}
exports.PrivateUserUpdatedDTO = PrivateUserUpdatedDTO;
//# sourceMappingURL=User.js.map